// React
import { create } from 'zustand';

// Store
import useProfileStore from '../store/profileStore.js';

// Other
import { doLogout, loadToken, verifyToken } from '../service/AuthService.js';
import { changePassword, login, register } from '../service/httpService/user/index.js';

const useAuthStore = create((set) => ({
	isLoggedIn: false,
	waitForLogin: true,
	sessionTimeLeft: 0,
	setLoggedIn: (loggedIn) => set({ isLoggedIn: loggedIn }),
	setWaitForLogin: (wait) => set({ waitForLogin: wait }),
	setSessionTimeLeft: (time) => set((state) => ({ sessionTimeLeft: typeof time === 'function' ? time(state.sessionTimeLeft) : time })),

	initAuth: async () => {
		const token = loadToken();
		if(!token) {
			set({ isLoggedIn: false, waitForLogin: false });
			return;
		}

		const res = await verifyToken(token).catch(() => false);
		if(!res) {
			set({ isLoggedIn: false, waitForLogin: false });
			return;
		}

		set({ isLoggedIn: res.data.success, waitForLogin: false });

		const { setUserEmail } = useProfileStore.getState();
		setUserEmail(res.data.message.email);
	},
	
	doLogout: async () => {
		doLogout();
		set({ isLoggedIn: false });
	},

	login: async (email, password) => {
		const loginResponse = await login({ email, password }).catch(() => false);
		if(!loginResponse) {
			return loginResponse;
		}

		const token = loginResponse.data.token;
		localStorage.setItem("token", token);
		localStorage.setItem('email', email);
		window.location.href = '/';

		return true;
	},

	register: async(data) => {
		const registerResponse = await register(data).catch(() => false);
		if(!registerResponse) {
			return { error: true, message: 'Fehler bei der Registrierung' };
		}

		if(registerResponse.data.register) {
			return true;
		}

		return { error: true, message: 'Diese Email ist nicht bekannt' };
	},

	changePassword: async(email, passwordLink, password) => {
		const changePasswordResponse = await changePassword(email, passwordLink, password).catch(() => false);
		if(!changePasswordResponse) {
			return { error: true, message: 'Fehler bei der Registrierung' };
		}

		if(changePasswordResponse.data.success) {
			return true;
		}

		return { error: true, message: 'Diese Email ist nicht bekannt' };
	}
}));

export default useAuthStore;